<template>
    <div>
        <v-row style="height: 63vh; overflow-y: scroll; overflow-x: hidden; margin-bottom: 10px;">
        <v-col cols="6"  class="" v-for="form in info" :key="form.name">
            <FormInput  :input_info="form" ></FormInput>
           
        </v-col>
        
        
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-btn dense block color="primary" @click="submitForm" class="text-lowercase">submit</v-btn>

            <p
                :class="submitted ? 'primary--text' : 'red--text'"
                class="caption text-center"
            >{{ message }}</p>
        </v-col>
    </v-row>
    </div>
   
</template>
<script>

import { Storage } from 'aws-amplify';
import FormInput from './FormInput.vue';
export default {
    name: 'user-form-1',
    components: {
        FormInput
    },
    data: () => ({
        map: false,
        mapStyle: "mapbox://styles/planet369/ckrdwj57j2w0m18mjfzizwmm3",
        mapboxAccessToken: 'pk.eyJ1IjoicGxhbmV0MzY5IiwiYSI6ImNrcmR3ZXZ6ZDBpbHgyb29laHR2d3pjcHUifQ.riIQ-PY811vasvyycMyn3g',
        coordinates: [-111.549668, 39.014],
        file: {},
        form: {
            first_name: '',
            last_name: '',
            location: '',
            linked_in_profile: '',
            instagram_account: '',
            video_url: '',
            request_id: '0f8603d5-c5f8-4f6d-b0fe-2f80357b6a48'
        },
        info: [{
              title: 'availability in September ',
              field_type: 'text-field',
              label: 'weekends and weekdays preferences',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            }, 
            
            {
              title: 'Which weeks of the schedule do you want to attend? ',
              field_type: 'checkbox',
              label: 'weeks',
              input_type: 'text',
              items: ['WATER WEEK 1 ', 'FOOD WEEK 2 ', 'SHELTER WEEK 3', 'COMMUNITY WEEK 4 '],
              value: [],
              input_value_condition: 'no, we already did this one:',
              value_2: '',
              label_2: 'action page link',
              input_id: 'first_action'
      
           
            }, 
            
            {
              title: 'Do you want to camp at the land?',
              field_type: 'select-input',
              label: '',
              input_type: 'text',
              items: ['yes', 'no', ],
              value: '',
              input_value_condition: 'no, we already did this one:',
              value_2: '',
              label_2: 'action page link',
              input_id: 'first_action'
      
            },
            {
              title: 'What do you want to learn?',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'What can you teach to others?',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
           
            {
              title: 'What are the skills that you are bringing with you?',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'Any food preferences or allergies we should know about?',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'name',
              field_type: 'text-field',
              label: 'name',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'email',
              field_type: 'text-field',
              label: '',
              input_type: 'email',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'phone',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
            {
              title: 'Do you have any other comments or remarks?',
              field_type: 'text-field',
              label: '',
              input_type: 'text',
      
              items: [],
              value: '',
              input_id: 'action_link'
      
            },
        
        ],
        message: '',
        submitted: false,
        submit: false
    }),
    methods: {
        createGenerativeNumber(){
            return Math.floor(100000000 + Math.random() * 900000000)
        },
        mapOpen() {
            this.map = true
            console.log(this.$refs.map)
            this.$refs.map.loadMap();
        },
        async put() {
            const result = await Storage.put("test.txt", "Hello");
            console.log(result)

        },
        async add() {
            this.submit = true

            const result = await Storage.put(this.createGenerativeNumber(), this.file);
            console.log(result)
            this.form.video_url = 'https://requests6b75835a6b6b43ceae12efe85948b077.s3.eu-central-1.amazonaws.com/public/'+ result.key

        },
        async getFiles() {
            Storage.list('/public/') // for listing ALL files without prefix, pass '' instead
                .then(result => console.log(result))
                .catch(err => console.log(err));
        },
        async submitForm() {
            await Storage.put(this.createGenerativeNumber() + "-report.json", JSON.stringify(this.info));
            
            window.location.reload()
            console.log("here")
            
        },
        reateGenerativeNumber() {
  return Math.floor(100000000 + Math.random() * 900000000)
}
    }
}
</script>